import React, { useState, useEffect } from "react";
import { getOrganizationSamples } from "../../controllers/OrganizationController";
import "./SelectedOrganization.css";

function OrganizationSamplesList({ id }) {
    const [samples, setSamples] = useState([]);

    useEffect(() => {
        getOrganizationSamples(id)
            .then((data) => {
                setSamples(data || []);
            })
            .catch((error) => {
                console.error("Error fetching organization samples:", error);
                setSamples([]);
            });
    }, [id]);

    return (
        <div className="SamplesList">
            <h3>Liste des prélèvements</h3>
            <ul>
                {samples.length > 0 ? (
                    samples.map((sample, index) => (
                        <li key={index}>
                            <p>{sample}</p>
                        </li>
                    ))
                ) : (
                    <li>Aucun prélèvement</li>
                )}
            </ul>
        </div>
    );
}

export default OrganizationSamplesList;
